import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { SOPreference } from '~/models/administration/soPreference';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class SOPreferencesService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.adminStock);
    }

    getSOPreference() {
        return this.http.get<SOPreference>(this._url());
    }

    updateSOPreference(model: any) {
        return this.client.put(this._url(), model);
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/SOPreferences${v}`);
    }
  }
